module.exports = __webpack_public_path__ + "static/media/8@3x.102dfb8e.png";